import { hash } from '@ember/helper'
import { LinkTo } from '@ember/routing'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import type { TOC } from '@ember/component/template-only'
import { type TeacherResourceCategoryEntry } from 'teacher-ui-client/contentful-client/entry-types'
import { getId } from 'teacher-ui-client/contentful-client/entry-types'

interface Signature {
  Element: HTMLUListElement
  Args: {
    categories: TeacherResourceCategoryEntry[]
  }
}

export const TeacherToolkitCategoryTiles: TOC<Signature> = <template>
  <ul class="flex flex-wrap gap-4" ...attributes>
    {{#each @categories as |category|}}
      <li class="relative">
        <LinkTo
          @query={{hash category=category.fields.path}}
          class="group border-dusty-black-50 flex h-full max-w-xs flex-col justify-between border-2 p-4 text-center"
        >
          <img
            src={{category.fields.image.fields.file.url}}
            alt={{category.fields.image.fields.title}}
            class="mx-auto my-4"
          />
          <span
            class="text-dusty-black-300 group-hover:text-oceany-blue-300 group-focus:text-oceany-blue-300 font-bold"
          >
            {{category.fields.name}}
          </span>
        </LinkTo>
        <ContentfulEdit @entryId={{getId category}} class="absolute top-0 right-0 p-2" />
      </li>
    {{/each}}
  </ul>
</template>
